const layers = {
    one: 'var(--layer-one-shadow)', //`0px 1px 2px ${palette.layerShadow}, 0px 1px 4px ${palette.layerSecondaryShadow}`,
    two: 'var(--layer-two-shadow)', //`0px 0px 10px ${palette.layerShadow}, 0px 0px 6px ${palette.layerSecondaryShadow}`,
    three: 'var(--layer-three-shadow)', //`0px 1px 1px ${palette.layerShadow}, 0px 1px 1px ${palette.layerSecondaryShadow}`,
    four: '',
    // leftSide: `0px 4px 10px ${palette.layerShadow}, 0px 2px 6px ${palette.layerSecondaryShadow}`,
    icons: 'var(--layer-icon-shadow)', //`0px 1px 1px ${palette.layerIconShadow}`,
    subtle: 'var(--layer-subtle-shadow)',
    // border: 'var(--layer-border)',
    // lightBorder: 'var(--layer-light-border)',
}

export default layers
